import React from 'react';
import ViewAllContent from '../components/pages/meeting-room/quickView-recent-calls/content';
import { connect, useDispatch, useSelector } from 'react-redux';

const MeetingRoomCallPage = (props) => {
  var divStyle = {
    zoom: props.zoom || 1,
  };

  const dispatch = useDispatch();

  const meetingRoomsQV = useSelector((state) => state.meetingRoomReducer.meetingRoomsInQV);
  const fetching = useSelector((state) => state.meetingRoomReducer.fetchingMeetingRooms);
  let meetingRooms = meetingRoomsQV.slice(0, 5);
  const isInCall = useSelector((state) => state.usersReducer.isInCall);
  const totalMeetingRooms = useSelector((state) => state.meetingRoomReducer.totalMeetingRooms);

  return (
    <div style={divStyle}>
      <ViewAllContent
        noHeader={props.noHeader}
        noRightMenu={props.noRightMenu}
        goToMeetingRooms={props.goToMeetingRooms}
        fetching={fetching}
        meetingRooms={meetingRooms}
        dispatch={dispatch}
        isMobileView={props.isMobileView || false}
        isInCall={isInCall}
        totalMeetingRooms={totalMeetingRooms}
      />
    </div>
  );
};

export default MeetingRoomCallPage;
